if (!customElements.get('featured-progress')) {
    class FeaturedProgress extends HTMLElement {
        constructor() {
            super();
            // 标志位，用于控制数字动画只执行一次
            this.animationPlayed = false;
        }

        connectedCallback() {
            this.observe();
        }

        observe() {
            // 创建 IntersectionObserver，阈值设为 30%，即元素进入视口30%时触发
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.animationPlayed) {
                        // 当元素完全进入视口且动画未执行时，执行动画
                        this.playAnimations();
                        // 标记动画已执行
                        this.animationPlayed = true;
                    }
                });
            }, { threshold: 0.3 });

            observer.observe(this);
        }

        playAnimations() {
            this.classList.add('active');
        }
    }

    customElements.define('featured-progress', FeaturedProgress);
}
